import axiosInstance from "./api";
import cache from "../utils/cacheUtil";

const STATS_CACHE_KEY = "outreach_monitor_stats";
const CACHE_DURATION = 15 * 60 * 1000; // 15 minutes

export const getOutreachStats = async ({ bypassCache = false } = {}) => {
  if (!bypassCache) {
    const cached = cache.get(STATS_CACHE_KEY);
    if (cached) return cached;
  }

  const response = await axiosInstance.get("/api/outreach/stats");
  const data = response?.data?.data ?? null;

  if (data) {
    cache.set(STATS_CACHE_KEY, data, {
      mode: "memory",
      absoluteTtl: CACHE_DURATION,
    });
  }

  return data;
};
